import { timeHhMmSsToDayjs } from '@/shared/lib/timeHelper'

import { RunFormValues } from './models/RunFormValues'

export const defaultRunValues: Partial<RunFormValues> = {
  name: '',
  description: '',
  groupId: null,
  startDepotId: null,
  finishDepotId: null,
  uiColorId: null,
  runCategoryId: null,
  weightCapacity: 0,
  volumeCapacity: 0,
  costFixed: 0,
  costPerKm: 0,
  costPerHour: 0,
  hiddenCostFixed: 0,
  hiddenCostPerKm: 0,
  hiddenCostPerHour: 0,
  overtimeCostPerHour1: 0,
  overtimeCostPerHour2: 0,
  speedScale: 1,
  targetUtilisation: 0,
  loadTime: timeHhMmSsToDayjs('00:00'),
  unloadTime: timeHhMmSsToDayjs('00:00'),
  overtimeKickIn1: timeHhMmSsToDayjs('00:00'),
  overtimeKickIn2: timeHhMmSsToDayjs('00:00'),
  maxLoads: 0,
  attributeIds: [],
  compartmentDefinitionIds: [],
  isActive: true,
  isPaidBreaks: false,
  breakDuration: timeHhMmSsToDayjs('00:00'),
  fatigueModelType: 0,
}